import core from "@/helpers/client";
const brandService = {
  async headBrandMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/brands`,
      params
    );
    return result;
  },
  async getBrandMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/brands`,
      params
    );
    return result;
  },
  async getBrandMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/brands/${id}`
    );
    return result;
  },
  async getBrandProductSkuListAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/brands/${id}/skus`
    );
    return result;
  },
  async createBrandMasterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/brands`,
      model
    );
    return result;
  },
  async createBrandApprovalAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/brands/approval`,
      model
    );
    return result;
  },
  async updateBrandMasterAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/brands/${id}`,
      model
    );
    return result;
  },
  async updateBrandApprovalAsync(id, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/brands/${id}/approval`,
      model
    );
    return result;
  },
  async deleteBrandMasterByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/brands/delete/${id}`
    );
    return result;
  },
  async uploadImgBrandMasterAsync(data) {
    const result = await core.upload(
      `${process.env.VUE_APP_BASE_URL_FILE_UPLOAD}api/v1/Files`, data
    );
    return result;
  },
};
export default brandService;
